import { combineEpics } from 'redux-observable';
import epicWrapper from '../utils/epics/epicWrapper';

// Auth epics
import loginEpic from './auth/login';
import logoutEpic from './auth/logout';
import readTokenEpic from './auth/readToken';
import createAccountEpic from './auth/createAccount';
import forgotPasswordEpic from './auth/forgotPassword';
import resetPasswordEpic from './auth/resetPassword';
import verifyPasswordTokenEpic from './auth/verifyPasswordToken';
import checkSSOEpic from './auth/checkSSO';
import loggedInEpic from './auth/loggedIn';

// Sites epics
import siteAddEpic from './sites/siteAdd';
import setCurrentSiteEpic from './sites/setCurrentSite';
import getSitesEpic from './sites/getSites';
import getUserSiteEpic from './sites/getSiteUser';
import deleteSiteEpic from './sites/deleteSite';
import editSiteEpic from './sites/editSite';
import editSiteLabelsEpic from './sites/editSiteLabels';

// Areas epics
import areaAddEpic from './areas/areaAdd';
import areaExpandEpic from './areas/areaExpand';
import setCurrentAreaEpic from './areas/setCurrentArea';
import getAreasEpic from './areas/getAreas';
import deleteAreaEpic from './areas/deleteArea';
import editAreaLoadEpic from './areas/editAreaLoad';
import editAreaEpic from './areas/editArea';

// Zones epics
import zoneAddEpic from './zones/zoneAdd';
import getZonesEpic from './zones/getZones';
import getZonesBySiteEpic from './zones/getZonesBySite';
import deleteZoneEpic from './zones/deleteZone';
import editZoneEpic from './zones/editZone';

// Locations epics
import locationAddEpic from './locations/locationAdd';
import locationEditEpic from './locations/locationEdit';
import getLocationsEpic from './locations/getLocations';
import getLocationsBySiteEpic from './locations/getLocationsBySite';
import getLocationsGeoJsonEpic from './locations/getLocationsGeoJson';
import deleteLocationEpic from './locations/deleteLocation';

// Categories epics
import getCategoriesEpic from './categories/getCategories';
import addCategoryEpic from './categories/addCategory';
import editCategoryEpic from './categories/editCategory';
import deleteCategoryEpic from './categories/deleteCategory';

// Groups epics
import getGroupsEpic from './groups/getGroups';
import addGroupEpic from './groups/addGroup';
import editGroup from './groups/editGroup';
import deleteGroup from './groups/deleteGroup';

// Tags epics
import addTagEpic from './tags/addTag';
import editTagEpic from './tags/editTag';
import getTagsEpic from './tags/getTags';
import updateTagsTimeEpic from './tags/updateTagsTime';
import streamTagsEpic from './tags/streamTags';
import deleteTagEpic from './tags/deleteTag';
import getHistoryEpic from './tags/getHistory';
import downloadHistoryEpic from './tags/downloadCSVHistory';
import bulkUploadEpic from './tags/bulkUpload';
import downloadTagListEpic from './tags/downloadTagList';
import getTagsFilterEpic from './tags/getFilters';

// Workflows epics
import getWorkflowsEpic from './workflows/getWorkflows';
import addWorkflowEpic from './workflows/addWorkflow';
import getWorkflowEpic from './workflows/getWorkflow';
import editWorkflowEpic from './workflows/editWorkflow';
import deleteWorkflowEpic from './workflows/deleteWorkflow';

// Triggers epics
import getTriggersEpic from './triggers/getTriggers';
import addTriggerEpic from './triggers/addTrigger';
import editTriggerEpic from './triggers/editTrigger';
import deleteTriggerEpic from './triggers/deleteTrigger';

// Actions epics
import getActionsEpic from './actions/getActions';
import addActionEpic from './actions/addAction';
import editActionEpic from './actions/editAction';
import deleteActionEpic from './actions/deleteAction';

// Users epics
import addUserEpic from './users/addUser';
import getUserEpic from './users/getUser';
import editUserEpic from './users/editUser';
import deleteSiteUserEpic from './users/deleteSiteUser';
import viewUserLinkEpic from './users/viewUserLink';

// Status
import getReferencePointEpic from './status/getReferencePoint';
import getAccessPointEpic from './status/getAccessPoint';
import getGatewayEpic from './status/getGateway';
import getStatusSummaryEpic from './status/getStatusSummary';
import deleteSiteAccessPoint from './status/deleteSiteAccessPoint';
import deleteSiteGateway from './status/deleteSiteGateway';
import resendVerifyEpic from './auth/resendVerify';

// Orgs
import getOrgsEpic from './organizations/getOrgs';
import getOrgUserRole from './organizations/getOrgUserRole';
import getOrgSitesEpic from './organizations/getOrgSites';

// zenoss 
import sendErrorReportEpic from  './report/sendError';

const rootEpic = combineEpics(
  ...[
    loginEpic,
    logoutEpic,
    readTokenEpic,
    createAccountEpic,
    forgotPasswordEpic,
    resetPasswordEpic,
    verifyPasswordTokenEpic,
    resendVerifyEpic,
    checkSSOEpic,
    loggedInEpic,
    // Sites
    siteAddEpic,
    setCurrentSiteEpic,
    editSiteEpic,
    deleteSiteEpic,
    getUserSiteEpic,
    getSitesEpic,
    editSiteLabelsEpic,
    // Aras
    areaAddEpic,
    areaExpandEpic,
    setCurrentAreaEpic,
    deleteAreaEpic,
    getAreasEpic,
    editAreaLoadEpic,
    editAreaEpic,
    // Zones
    zoneAddEpic,
    deleteZoneEpic,
    getZonesEpic,
    getZonesBySiteEpic,
    editZoneEpic,
    // Locations
    locationAddEpic,
    locationEditEpic,
    deleteLocationEpic,
    getLocationsEpic,
    getLocationsBySiteEpic,
    getLocationsGeoJsonEpic,
    // Categories
    addCategoryEpic,
    editCategoryEpic,
    deleteCategoryEpic,
    getCategoriesEpic,
    // Groups
    addGroupEpic,
    editGroup,
    deleteGroup,
    getGroupsEpic,
    // Tags
    addTagEpic,
    editTagEpic,
    getTagsEpic,
    updateTagsTimeEpic,
    deleteTagEpic,
    streamTagsEpic,
    getHistoryEpic,
    downloadHistoryEpic,
    bulkUploadEpic,
    downloadTagListEpic,
    getTagsFilterEpic,
    // Users
    addUserEpic,
    getUserEpic,
    editUserEpic,
    deleteSiteUserEpic,
    viewUserLinkEpic,
    // status
    getReferencePointEpic,
    getAccessPointEpic,
    getGatewayEpic,
    getStatusSummaryEpic,
    deleteSiteAccessPoint, // Delete site Access point.
    deleteSiteGateway, // Delete site Gateway.
    // Workflows
    getWorkflowsEpic,
    getWorkflowEpic,
    addWorkflowEpic,
    editWorkflowEpic,
    deleteWorkflowEpic,
    // Triggers
    getTriggersEpic,
    addTriggerEpic,
    editTriggerEpic,
    deleteTriggerEpic,
    // Action
    getActionsEpic,
    addActionEpic,
    editActionEpic,
    deleteActionEpic,
    // Orgs
    getOrgsEpic,
    getOrgSitesEpic,
    getOrgUserRole,
    // zenoss error
    sendErrorReportEpic

  ].map(epicWrapper)
);

export default rootEpic;



// WEBPACK FOOTER //
// ./src/epics/index.js